module.exports = __webpack_public_path__ + "static/media/michael-foord.8adc1583.png";